module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div id=\"")
    ; __append(escapeFn( node.id ))
    ; __append("\" parent=\"")
    ; __append(escapeFn( node.parent.id ))
    ; __append("\" class=\"rule-container node\">\n    <div class=\"rule-header\">\n        <div style=\"text-align: right\">\n            <button class=\"btn btn-red\" on-click=\"onRemoveClick\">Удалить</button>\n        </div>\n    </div>\n    <div class=\"rule-body\">\n        <div class=\"table w100\">\n            <div>\n                <div class=\"filter col\" style=\"width: 20%\">\n                    <control type=\"select\" target=\"")
    ; __append(escapeFn( node.path("tree") + ".data.filterid" ))
    ; __append("\" source=\"filters\" title-key=\"label\" value-key=\"id\" on-select=\"onFilterSelect\" show-empty/>\n                </div>\n                <div class=\"operator col\" style=\"width: 10%\"></div>\n                <div class=\"value col\" style=\"width: 30%\"></div>\n                <div class=\"options col\"></div>\n            </div>\n        </div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}